import { COPY } from '../../copy/firstRun'
import { SettingsPrivacyLink } from '../consent/SettingsPrivacyLink'
import { Section, TOKENS } from '../ui/dashboard-primitives'

/**
 * Where the analysis would begin, when the person has not agreed to AI processing (#399, CS-D14; artboard
 * `R2-dashboard-web`): one note of 14 words, in place of the three sections that share the analysis.
 * "No written analysis." and "AI models write it. That needs your agreement.", with "Turn it on in
 * Settings", the way to Settings › Privacy (CO-D3): the note informs and never asks in place.
 *
 * It keeps the first of the three sections' number and eyebrow, so the page's own numbering does not
 * skip, and sits where the analysis would be (Law of Common Region). It is a status, not an alert: the
 * dashboard is the person's data and the missing piece is a choice they made.
 */
export function AiOffAnalysis() {
  return (
    <Section index="06" eyebrow="Analysis">
      <div
        role="status"
        className="flex max-w-[620px] flex-col rounded-2xl px-6 py-[22px]"
        style={{ backgroundColor: TOKENS.warmDark }}
      >
        <p className="text-xl font-medium tracking-[-0.01em] text-(--text-cream)">{COPY.aiOffAnalysisTitle}</p>
        <p className="mt-2.5 max-w-[54ch] text-sm leading-relaxed text-(--text-cream-soft)">
          {COPY.aiOffAnalysisBody}
        </p>
        <SettingsPrivacyLink className="mt-2 self-start" />
      </div>
    </Section>
  )
}
